import Routes from "../../api/routes"; // API endpoint routes
import { post } from "../../api";
import { toggleLoader } from "./ui";
const { CONTACT_US, KLAVIYO_SUBSCRIBE } = Routes;

/*******************
@purpose :  send mail to admin
@Parameter : {}
@Author : INIC
******************/
export const sendContactUs = (data) => (dispatch) => {
  return post(CONTACT_US, true, data).then((res) => {
    dispatch(toggleLoader("content_loader", false));
    if (res.data) {
      return res.data;
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  Add email to email list in klaviyo dashboard
@Parameter : {data}
@Author : INIC
******************/
export const klaviyoSubscribe = (data) => (dispatch) => {
  return post(KLAVIYO_SUBSCRIBE, true, data, true).then((res) => {
    dispatch(toggleLoader("content_loader", false));
    if (res.data) {
      return res.data;
    }
    return Promise.reject(res);
  });
};
